<template>
    <!-- Footer -->
    <div>
        <section color="blue-grey" class="page-footer font-small lighten-5 pt-0">
            <container class="mt-5 text-center text-md-left footer-color">
                <row class="color-scheme">
                    <div class="color-item col-xl-2 col-lg-2 col-md-2 col-sm-2 animated fadeInUp hoverable b-color-red"></div>
                    <div class="color-item col-xl-2 col-lg-2 col-md-2 col-sm-2 animated fadeInUp hoverable b-color-orange"></div>
                    <div class="color-item col-xl-2 col-lg-2 col-md-2 col-sm-2 animated fadeInUp hoverable b-color-yellow"></div>
                    <div class="color-item col-xl-2 col-lg-2 col-md-2 col-sm-2 animated fadeInUp hoverable b-color-green"></div>
                    <div class="color-item col-xl-2 col-lg-2 col-md-2 col-sm-2 animated fadeInUp hoverable b-color-blue"></div>
                    <div class="color-item col-xl-2 col-lg-2 col-md-2 col-sm-2 animated fadeInUp hoverable b-color-violet"></div>
                </row>
                <!-- <row class="mt-3">
                    <column md="3" lg="4" xl="3" class="mb-4 dark-grey-text">
                        <h6 class="text-uppercase font-weight-bold"><strong>ComColors</strong></h6>
                        <hr class="deep-blue accent-2 mb-4 mt-0 d-inline-block mx-auto" style="width: 60px"/>
                        <p>ComColors IS A MODEL OF COMMUNICATION to better know and understand the other. It is easy to understand operational and pedagogical model. All concepts are consistent and overlapping each other. They provide reading overall and specific times on each personality type.</p>
                    </column>
                    <column md="2" lg="2" xl="2" class="mb-4 dark-grey-text">
                        <h6 class="text-uppercase font-weight-bold"><strong>Products</strong></h6>
                        <hr class="deep-blue accent-2 mb-4 mt-0 d-inline-block mx-auto" style="width: 60px"/>
                        <p><a href="#!" class="dark-grey-text">Psychometrics</a></p>
                        <p><a href="#!" class="dark-grey-text">6 Personality Types</a></p>
                        <p><a href="#!" class="dark-grey-text">Certification</a></p>
                    </column>
                    <column md="3" lg="2" xl="2" class="mb-4 dark-grey-text">
                        <h6 class="text-uppercase font-weight-bold"><strong>Useful links</strong></h6>
                        <hr class="deep-blue accent-2 mb-4 mt-0 d-inline-block mx-auto" style="width: 60px"/>
                        <p><a href="#!" class="dark-grey-text">Your Account</a></p>
                        <p><a href="#!" class="dark-grey-text">Leave a message</a></p>
                        <p><a href="#!" class="dark-grey-text">Conditions d'Utilisation</a></p>
                        <p><a href="#!" class="dark-grey-text">Help</a></p>
                    </column>
                    <column md="4" lg="3" xl="3" class="mb-4 dark-grey-text">
                        <h6 class="text-uppercase font-weight-bold"><strong>Contact</strong></h6>
                        <hr class="deep-blue accent-2 mb-4 mt-0 d-inline-block mx-auto" style="width: 60px"/>
                        <p><i class="fa fa-home mr-3"></i> 17 Bowater Road Woolwich Riverside</p>
                        <p><i class="fa fa-envelope mr-3"></i> sylvaine.sallet@comcolors.com</p>
                        <p><i class="fa fa-phone mr-3"></i> + 44(0)2034450792</p>
                    </column>
                </row> -->
            </container>
            <div class="footer-copyright text-center py-3 font-weight-bold">
                <container fluid>
                    &copy; {{ year }} ComColors
                </container>
            </div>
        </section>
    </div>
    <!-- Footer -->
</template>

<script>
import { Footer, Container, Row, Column } from 'mdbvue';

export default {
    name: 'Footer',
    components: {
        Container,
        Row,
        Column,
        Footer
    },
    computed: {
        year(){
            let today = new Date();
            let year = today.getFullYear();
            return year;
        }
    }
};
</script>

<style scoped>
.footer-color {
background: rgba(128, 128, 128, 0.12);
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue